import React from "react";
import styled, { css } from "styled-components";

const TabHeadingOuter = styled.div<ITabHeadingOuter>`
  border-top-left-radius: ${({ theme }) => theme.radii[1]};
  border-top-right-radius: ${({ theme }) => theme.radii[1]};
  background-color: ${({ theme }) => theme.colors.secondaryTwo};
  color: ${({ theme }) => theme.colors.primary};
  ${(props) =>
    props.isCentered &&
    css`
      text-align: center;
    `}
`;

const TabHeadingInner = styled.div<ITabHeadingInner>`
  display: inline-block;
  padding: ${({ theme }) => theme.space[2]};
  border-top-left-radius: ${({ theme }) => theme.radii[1]};
  border-top-right-radius: ${({ theme }) => theme.radii[1]};
  color: ${({ theme }) => theme.colors.primary};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    ${(props) =>
      props.isBlock &&
      css`
        display: block;
      `}
  }
`;

const TabHeadingTitle = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes[1]};
`;

interface IOwnProps {
  title: React.ReactNode;
}

interface ITabHeadingOuter {
  hasBorder?: boolean;
  isCentered?: boolean;
}

interface ITabHeadingInner {
  isBlock?: boolean;
}

type Props = IOwnProps & ITabHeadingOuter & ITabHeadingInner;

const TabHeading: React.FC<Props> = ({
  hasBorder = false,
  isBlock = false,
  isCentered = false,
  title,
}) => (
  <TabHeadingOuter isCentered={isCentered} hasBorder={hasBorder}>
    <TabHeadingInner isBlock={isBlock}>
      <TabHeadingTitle>{title}</TabHeadingTitle>
    </TabHeadingInner>
  </TabHeadingOuter>
);

export default TabHeading;
